import { View } from '../view';

export abstract class DynamicComponent {
  view: View;
}
